import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import { Input } from '@src/elements/input/input'
import { Subtitle1 } from '@src/elements/typography/typography'

@Component({
  computed: {
    workoutName: {
      get () {
        return this.$store.state.new_workout.name
      },
      set (name: string) {
        this.$store.state.new_workout.name = name
      }
    }
  }
})
export class WorkoutName extends Vue {

  @Prop({ required: false, default: false })
  disabled: boolean

  private workoutName: string

  render (h: CreateElement) {
    if (this.disabled) {
      return <Subtitle1 class='name'>{this.workoutName}</Subtitle1>
    }

    return <Input label={this.$t('PAGE.CLUB.ARRANGEMENT_SETTINGS.NAME')}
                  class={ this.workoutName ? 'name' : 'name-error'}
                  valueChanged={(value: string) => this.workoutName = value}
                  value={this.workoutName}
                  ref='workoutNameInput'
                  maxLength={50} />
  }
}
